import { Button, Typography } from "@mui/material";
import React, { useState } from "react";
import ShareWithThirdModal from "../../../components/benef/ShareWithThirdModal";
import { useTranslation } from "react-i18next";

const ShareModal: React.FC<{
  id: string;
  onAddThirdParties: any;
  profile: any;
}> = ({ id, onAddThirdParties, profile }) => {
  const { t } = useTranslation("common");
  const [open, setOpen] = useState(false);
  const openModal = () => setOpen(true);
  const close = () => setOpen(false);
  return (
    <>
      <Button
        onClick={openModal}
        variant="contained"
        sx={{ width: "100%", height: "50px" }}
      >
        <Typography sx={{ ml: 1 }}>
          {t("third_party.profiles.share")}
        </Typography>
      </Button>
      <ShareWithThirdModal
        open={open}
        close={close}
        profiles={[{ profile }]}
        onFinish={() => {}}
        onAddThirdParties={onAddThirdParties}
      />
    </>
  );
};

export default ShareModal;
